import { NgClass } from "@angular/common";
import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { RouterLink } from "@angular/router";
import { IconStackedComponent } from "@components/icon-stacked/icon-stacked.component";
import { TextmultilineComponent } from "@components/textmultiline/textmultiline.component";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { AvtalMediatorService } from "~app/features/virkeskop/services/avtal-mediator.service";
import { IAtgardStatus, IAtgardStatusTooltip } from "../models/atgardheadericons-models";

@Component({
    selector: "rask-atgard-header-icon",
    templateUrl: "./atgard-header-icon.component.html",
    styleUrls: ["./atgard-header-icon.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        IconStackedComponent,
        TextmultilineComponent,
        RouterLink
    ]
})
export class AtgardHeaderIconComponent implements OnInit, OnDestroy {
    @Input() status: IAtgardStatus;

    protected isDirty = false;

    private readonly avtalMediatorService = inject(AvtalMediatorService);
    private readonly ngUnsubscribe$ = new Subject<void>();

    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    ngOnInit(): void {
        this.avtalMediatorService.dirty$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(dirty => {
                this.isDirty = dirty;
            });
    }

    protected clickTooltip(tooltip: IAtgardStatusTooltip, event: MouseEvent) {
        if(ObjectUtils.isNullOrUndefined(tooltip.link?.onClick)) {
            return;
        }

        tooltip.link.onClick(event);
    }
}
